export enum OrganizationUnitType {
    CebiaSupervizor = 0,
    Supervizor = 1,
    FlexGroup = 2,
    Partner = 3,
    Vz = 4,
    BranchOffice = 5,
    Special = 6,
    Manager = 7,
    Api = 8,
    SpecialVz = 9,
    AutoKam = 10,
}

export const OrganizationUnitTypes: [OrganizationUnitType, string][] = [
    [OrganizationUnitType.CebiaSupervizor, 'Cebia supervizor'],
    [OrganizationUnitType.Supervizor, 'Supervizor'],
    [OrganizationUnitType.FlexGroup, 'Flex group'],
    [OrganizationUnitType.Partner, 'Partner'],
    [OrganizationUnitType.Vz, 'VZ'],
    [OrganizationUnitType.BranchOffice, 'Pobočka'],
    [OrganizationUnitType.Special, 'Special'],
    [OrganizationUnitType.Manager, 'Manažer'],
    [OrganizationUnitType.Api, 'API'],
    [OrganizationUnitType.SpecialVz, 'Special VZ'],
    [OrganizationUnitType.AutoKam, 'AutoKam'],
]

export const getOrganizationUnitTypeName = (type: OrganizationUnitType | undefined) => {
    return type !== undefined ? OrganizationUnitTypes.find(([key]) => key === type)?.[1] : undefined
}